import { httpsCallable } from 'firebase/functions';
import { create } from 'zustand';
import { functions } from '../../../shared/config/firebase';

interface ReferralCodeResponse {
  isValid: boolean;
  discountPercent?: number;
  applyResultMessage?: string;
  error?: string;
}

interface OnboardingState {
  currentStep: number;
  totalSteps: number;
  referralCode: string;
  referralCodeResult: string;
  referralCodeError: string;
  whatBringsYouResponse: string[];
  setCurrentStep: (step: number | undefined) => void;
  setTotalSteps: (steps: number) => void;
  setReferralCode: (code: string) => void;
  checkReferralCode: (code: string) => Promise<boolean>;
  setWhatBringsYouResponse: (response: string[]) => void;
}

const initialState = {
  currentStep: 0,
  totalSteps: 12,
  referralCode: '',
  referralCodeResult: '',
  referralCodeError: '',
  whatBringsYouResponse: [],
};

export const useOnboardingStore = create<OnboardingState>()((set) => ({
  ...initialState,

  setCurrentStep: (step: number | undefined) => {
    set({ currentStep: step });
  },
  setTotalSteps: (steps: number) => {
    set({ totalSteps: steps });
  },
  setReferralCode: (code: string) => {
    set({ referralCode: code });
  },
  setWhatBringsYouResponse: (response: string[]) => {
    set({ whatBringsYouResponse: response });
  },
  checkReferralCode: async (code: string) => {
    const referralCodeCheckCallable = httpsCallable<{ code: string }, ReferralCodeResponse>(functions, 'checkReferralCode');
    const result = await referralCodeCheckCallable({ code });
    const response = result.data;
    set({ referralCode: code, referralCodeResult: response.applyResultMessage ?? '', referralCodeError: response.error ?? '' });
    return response.isValid;
  },
}));
